import { render, staticRenderFns } from "./ptkbScreen.vue?vue&type=template&id=b60500aa"
import script from "./ptkbScreen.vue?vue&type=script&lang=js"
export * from "./ptkbScreen.vue?vue&type=script&lang=js"
import style0 from "./ptkbScreen.vue?vue&type=style&index=0&id=b60500aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports